import axios from "axios";

const CSRF_COOKIE_NAME = "zion_csrf";
const CSRF_HEADER_NAME = "X-CSRF-Token";
const STATE_CHANGING_METHODS = new Set(["post", "put", "patch", "delete"]);

function readCsrfCookie() {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + CSRF_COOKIE_NAME + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : null;
}

// Defaults to a relative base so requests resolve as same-origin paths
// (e.g. "/auth/signup") through this frontend's own nginx reverse proxy.
// The zion-auth container is only reachable inside the Docker network under
// its container name, so the browser must never be pointed at it directly -
// only set REACT_APP_AUTH_ENDPOINT to an absolute URL for setups where the
// auth backend is genuinely served from a different origin.
const authHttp = axios.create({
  baseURL: process.env.REACT_APP_AUTH_ENDPOINT || "",
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

authHttp.interceptors.request.use((config) => {
  const method = (config.method || "").toLowerCase();
  if (STATE_CHANGING_METHODS.has(method)) {
    const csrfToken = readCsrfCookie();
    if (csrfToken) {
      config.headers[CSRF_HEADER_NAME] = csrfToken;
    }
  }
  return config;
});

// Set by authApi.js at module load, avoiding a circular import between the
// two files (authApi.js is authHttp's own consumer for the actual requests).
let unauthorizedHandler = null;
export function onUnauthorized(handler) {
  unauthorizedHandler = handler;
}

authHttp.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && unauthorizedHandler) {
      unauthorizedHandler();
    }
    return Promise.reject(error);
  }
);

export default authHttp;
